module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-45.78755b9e.png";